<div class="row">
  <div class="requestCOIOuter fixHeightMobile" (window:resize)="onresize($event)">
    <div class="request-coi-page">
      <div class="order-view-sec breadcrumbOuter padding-0" id="orderView1" [ngClass]="'col-md-12'">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb pl-0">
            <li class="breadcrumb-item active">
              <a href="javascript:void(0)" (click)="navigateToLandingPage()">Seed Replant</a>
              <i class="fas fa-angle-right"></i>
            </li>
            <li class="breadcrumb-item breadcrumbColor xs-pr-0">
              <span id="spnBreadcrum">{{breadcrumbtext}}</span>
            </li>
          </ol>
        </nav>
      </div>
      <div class="OrderReleaseTop">
        <div class="row px-3 pt-1">
          <!--Sold To Select List-->
          <div class=" col-md-4 material-select arrow-remove withBordr" [class.cpp-create-soldTo]="!soldToAccount">
            <ng-select name="ddlSoldTo"
                       [items]="soldToAccountList"
                       class="custom-select-grower grower-add-drop pb-0"
                       [class.ng-select-disabled]="!soldToAccount"
                       [virtualScroll]="true"
                       [(ngModel)]="soldToAccount"
                       bindLabel="accountNameCityState"
                       [disabled]="true"
                       bindValue="accountNumber"
                       placeholder="Sold To: (Will Display after selection of Ship To):">
              <ng-template ng-label-tmp let-item="item" let-index="index">
                <div class="dropdown-template">
                  <div class="row">
                    <div class="col-md-12  mb-2" [ngClass]="{'acc-details': isEditMode}">
                      <div class="mb-0 mt-2">
                        {{item.accountName}}
                      </div>
                      <div class="mb-0">
                        {{item.address1}},  {{item.city}}, {{item.state}} - {{item.zipCode}}
                      </div>
                      <div class="mb-0">
                        {{item.primaryPhoneNumber}}
                      </div>
                      <div>
                        Account #: {{item.accountNumber}}
                      </div>
                    </div>
                  </div>
                </div>
              </ng-template>
            </ng-select>
          </div>

          <!--Ship To Select List-->
          <div class=" col-md-4 material-select arrow-remove withBordr">
            <ng-select name="ddlShipTo"
                       [items]="shipToAccountList"
                       class="custom-select-grower grower-add-drop pb-0"
                       [virtualScroll]="true"
                       [(ngModel)]="shipToAccount"
                       bindLabel="accountNameCityState"
                       [disabled]="true"
                       bindValue="accountNumber"
                       placeholder="Ship To: *">
              <ng-template ng-label-tmp let-item="item" let-index="index">
                <div class="dropdown-template">
                  <div class="row">
                    <div class="col-md-12  mb-2" [ngClass]="{'acc-details': isEditMode}">
                      <div class="mb-0 mt-2">
                        {{item.accountName}}
                      </div>
                      <div class="mb-0">
                        {{item.address1}},  {{item.city}}, {{item.state}} - {{item.zipCode}}
                      </div>
                      <div class="mb-0">
                        {{item.primaryPhoneNumber}}
                      </div>
                      <div>
                        Account #: {{item.accountNumber}}
                      </div>
                    </div>
                  </div>
                </div>
              </ng-template>
            </ng-select>
          </div>

          <!--Credit To Select List-->
          <div class=" col-md-4 material-select arrow-remove withBordr" [class.cpp-create-soldTo]="!creditToAnotherLocation">
            <ng-select name="ddlCreditTo"
                       [items]="creditToList"
                       class="custom-select-grower pb-0 grower-add-drop"
                       [virtualScroll]="true"
                       [(ngModel)]="creditToAccount"
                       bindLabel="accountNameCityState"
                       bindValue="accountNumber"
                       [disabled]="true"
                       placeholder="Credit to Account:">
              <ng-template ng-label-tmp let-item="item" let-index="index">
                <div class="dropdown-template">
                  <div class="row">
                    <div class="col-md-12  mb-2" [ngClass]="{'acc-details': isEditMode}">
                      <div class="mb-0 mt-2">
                        {{item.accountName}}
                      </div>
                      <div class="mb-0">
                        {{item.address1}},  {{item.city}}, {{item.state}} - {{item.zipCode}}
                      </div>
                      <div class="mb-0">
                        {{item.primaryPhoneNumber}}
                      </div>
                      <div>
                        Account #: {{item.accountNumber}}
                      </div>
                    </div>
                  </div>
                </div>
              </ng-template>
            </ng-select>
          </div>
        </div>
      </div>
      <div class="OrderReleaseTop">
        <div class="row px-3 pt-1 pb-0 grower-add-dropDown">
          <!--Grower To Select List-->
          <div class="col-md-6 material-select arrow-remove">
            <ng-select name="ddlGrowerDetails"
                       [items]="growerList"
                       class="custom-select-grower grower-add-drop pb-0"
                       [(ngModel)]="growerGMK"
                       [virtualScroll]="true"
                       bindLabel="growerNameCityState"
                       placeholder="Grower:"
                       [loading]="growerLoading"
                       bindValue="gmk"
                       [closeOnSelect]="true"
                       [disabled]="true">
              <ng-template ng-label-tmp let-item="item" let-index="index">
                <div class="dropdown-template">
                  <div class="row">
                    <div class="col-md-12  mb-2" [ngClass]="{'acc-details': isEditMode}">
                      <div class="mb-0 mt-2">
                        {{item.businessName ? item.businessName :item.growerName}}
                      </div>
                      <div class="mb-0">
                        {{item.address1}},  {{item.city}}, {{item.state}} - {{item.zip}}
                      </div>
                      <div class="mb-0">
                        {{item.primaryPhoneNumber}}
                      </div>
                      <div>
                        <span class="grower-gln" [ngOptionHighlight]="search">
                          Grower GMK: {{item.gmk}}
                        </span>
                        <span class="grower-gln" [ngOptionHighlight]="search">
                          Grower GLN: {{item.growerGLN}}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                <div class="dropdown-template">
                  <div class="row">
                    <div class="col-md-8">
                      <h4 class="name greenColor" [ngOptionHighlight]="search">
                        {{item.businessName}}
                      </h4>
                      <p class="address" [ngOptionHighlight]="search">
                        {{item.address1}},  {{item.city}}, {{item.state}} - {{item.zip}}
                      </p>
                      <p class="phoneNo" [ngOptionHighlight]="search">
                        {{item.primaryPhoneNumber}}
                      </p>
                      <p class="grower-nos">
                        <span class="grower-gln" [ngOptionHighlight]="search">
                          Grower GMK: {{item.gmk}}
                        </span>
                        <span class="grower-gln" [ngOptionHighlight]="search">
                          Grower GLN: {{item.growerGLN}}
                        </span>
                      </p>
                    </div>
                    <div class="col-md-3 orderId-detail text-right">
                      Order:
                      <p *ngIf="item.growerOrderList.length > 0">{{item.OrderNumber}}</p>
                    </div>
                  </div>
                </div>
              </ng-template>
            </ng-select>
          </div>

          <!--Non subscriber Email Address-->
          <div class="col-md-3 padding-t10" *ngIf="isShowNonSubEmail">
            <mat-form-field class="wide100" [ngClass]="{valid : (isNotValid ==false)}">
              <mat-label>Non-Subscriber Email:</mat-label>
              <input matInput type="text" name="emailAddress" maxlength="500"
                     placeholder="(Separate multiple email addresses by a semi-colon)"
                     [(ngModel)]="emailAddress"
                     [pattern]="masterConstants.EMAIL_PATTERN"
                     email="true" readonly>
              <mat-error *ngIf="isNotValid">
                This is invalid e-mail address(s). Separate multiple email addresses by a semi-colon.
              </mat-error>
            </mat-form-field>
          </div>
        </div>
      </div>

      <div class="OrderReleaseTop mb-0 pt-1">
        <div class="row listing-action-items grower-page">
          <div class="col-lg-7 col-md-7">
            <div>
              <p class="lead padding-t7 padding-l10 mb-0"> Failed Product </p>
            </div>
          </div>
          <div class="col-md-5 col-lg-5">
            <div class="d-block d-sm-block xs-pl-10 xs-pr-10 text-right">
              <div class="display-ib wAuto">
                <mat-paginator #failedPaginator [pageSize]="50" [pageSizeOptions]="masterConstants.PAGE_SIZE_OPTIONS"></mat-paginator>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="OrderReleaseTop">
        <div class="row">
          <div class="col-md-12">
            <div class="tableContainer prodTableContainer" id="returnRequestView">
              <table mat-table #requestTable [dataSource]="productItemsDataSource" multiTemplateDataRows class="matTables seedCropLossTable">
                <ng-container matColumnDef="{{column}}" *ngFor="let column of displayedColumns">
                  <div *ngIf="column=='product'"><th mat-header-cell *matHeaderCellDef class="prodNameBlock">Product</th>
            </div>
            <div *ngIf="column=='treatment'"><th mat-header-cell *matHeaderCellDef class="treatment text-center">Treatment</th></div>
            <div *ngIf="column=='lotNumber'"><th mat-header-cell *matHeaderCellDef class="lotNo padding-l10 text-left">Lot Number</th></div>
            <div *ngIf="column=='eligibleUnits'"><th mat-header-cell *matHeaderCellDef class="units text-center">Eligible Units</th></div>
            <div *ngIf="column=='unitsSoldToGrower'"><th mat-header-cell *matHeaderCellDef class="units text-center">Units Sold To Grower</th></div>
            <div *ngIf="column=='failedUnits'"><th mat-header-cell *matHeaderCellDef class="dumpedLines text-center">Failed Units</th></div>
            <div *ngIf="column=='uom'"><th mat-header-cell *matHeaderCellDef class="uom text-center">UOM</th></div>
            <div *ngIf="column=='problemDescription'"><th mat-header-cell *matHeaderCellDef class="notes text-center">Description of the problem</th></div>
            <div *ngIf="column=='approverNotes'" [ngClass]="{'d-none': !isApproverUser}">
              <th mat-header-cell *matHeaderCellDef class="notes text-center" [ngClass]="{'d-none': !isApproverUser}">Approver Notes</th>
            </div>
            <td mat-cell *matCellDef="let element">
              <div *ngIf="column=='product'" class="order-info-outer">
                <div class="order-info">
                  <p class="prod-id">{{element.itemVendorName}}</p>
                  <p class="prod-name" matTooltip="{{element.itemNumber}}" [matTooltipPosition]="'above'" matTooltipClass="whiteFontCpp">{{element.itemDescription}}</p>
                </div>
              </div>
              <div *ngIf="column=='treatment'" class="measureUnit text-center font-14">
                <p class="mb-0"> {{element.treatmentDescription}} </p>
              </div>

              <div *ngIf="column=='lotNumber'" class="measureUnit text-left">
                <p class="mb-0 font18"> {{element.lotNumber}} </p>
              </div>

              <div *ngIf="column=='eligibleUnits'" class="measureUnit text-center">
                <p class="mb-0 font18"> {{element.eligibleUnits}} </p>
              </div>

              <div *ngIf="column=='unitsSoldToGrower'" class="measureUnit text-center">
                <p class="mb-0 font18"> {{element.unitsPurchased}} </p>
              </div>

              <div *ngIf="column=='failedUnits'" class="quantityBlock text-center">
                <p class="mb-0 font18"> {{element.unitsFailed}} </p>
              </div>

              <div *ngIf="column=='uom'" class="measureUnit text-center">
                <p class="mb-0 font18"> {{element.uom}} </p>
              </div>

              <div *ngIf="column=='problemDescription'" class="measureUnit text-center">
                <textarea readonly type="text" class="notesTxt descriptionBorder" [(ngModel)]="element.problemDescription" maxlength="200"></textarea>
              </div>

              <div *ngIf="column=='approverNotes'" [ngClass]="{'d-none': !isApproverUser}" class="measureUnit text-center">
                <textarea id="txtFailedApproverNotes_{{element.itemNumber}}" type="text" class="notesTxt" [(ngModel)]="element.approverNotes" maxlength="200" (input)="hasDataChanged();"></textarea>
              </div>
            </td>
            </ng-container>

            <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
            <ng-container matColumnDef="expandedDetail">
              <td mat-cell class="product-details" *matCellDef="let element" [attr.colspan]="displayedColumns.length">
                <div class="seller-info pb-2">
                  <div class="row">
                    <div class="w-25 padding-r0 text-left padding-l15">
                      <span class="seller-name pl-2 originalGrowerText">Original Grower Invoice#:</span>
                      <span class="customer-po-input inVoiceInput borderBottom originalGrowerText">
                        {{element.growerInvoice}}
                      </span>
                    </div>
                    <div class="w-24 padding-l0  padding-l10">
                      <span class="seller-name originalGrowerText">Original Planting Date:</span>
                      <span class="text-center deliveryDatePicker borderBottom originalGrowerText">
                        {{element.plantingDate | date: masterConstants.DATE_MMDDYYYY}}
                      </span>
                    </div>
                    <div class="w-15">
                      <span class="customer-po originalGrowerText">
                        Grower License#:
                      </span>
                      <span class="customer-po-input inVoiceInput borderBottom originalGrowerText">
                        {{element.licenseNumber}}
                      </span>
                    </div>
                    <div class="w-15 padding-r0 text-left padding-l15" *ngIf="IsShowTreatment(element)">
                      <span class="seller-name  pl-2 originalGrowerText">Treatment#:</span>
                      <span class="customer-po-input inVoiceInput borderBottom originalGrowerText">
                        {{element.replantTreatmentDescription}}
                      </span>
                    </div>
                    <div class="padding-r0 text-left padding-l15" *ngIf="IsShowTreatment(element)">
                      <span class="seller-name  pl-2 originalGrowerText">Other Treatment#:</span>
                      <span class="customer-po-input inVoiceInput borderBottom originalGrowerText">
                        {{element.otherTreatment}}
                      </span>
                    </div>
                  </div>
                </div>
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky:true;"></tr>
            <tr mat-row *matRowDef="let element; columns: displayedColumns;"
                class="example-element-row"
                [class.example-expanded-row]="expandedElement === element"
                (click)="expandedElement = expandedElement === element ? null : element"></tr>
            <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
            </table>
          </div>
        </div>
      </div>
    </div>

    <!--Replant Grid-->
    <div class="OrderReleaseTop mb-0 pt-2">
      <div class="row listing-action-items grower-page">
        <div class="col-lg-7 col-md-7">
          <div>
            <p id="pReplantProduct" class="lead padding-t7 pad-left20"> Replant Product </p>
          </div>
        </div>
        <div class="col-md-5 col-lg-5">
          <div class="d-block d-sm-block xs-pl-10 xs-pr-10 text-right">
            <div class="display-ib wAuto">
              <mat-paginator #replantPaginator [pageSize]="50" [pageSizeOptions]="masterConstants.PAGE_SIZE_OPTIONS"></mat-paginator>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="OrderReleaseTop margin-b5">
      <div class="row">
        <div class="col-md-12">
          <div class="tableContainer prodTableContainer" id="returnRequestView">
            <table mat-table #requestTable [dataSource]="replantProductItemsDataSource" multiTemplateDataRows class="matTables seedCropLossTable">
              <ng-container matColumnDef="{{column}}" *ngFor="let column of replantDisplayedColumns">
                <div *ngIf="column=='product'"><th mat-header-cell *matHeaderCellDef class="prodNameBlock">Product</th>
          </div>
          <div *ngIf="column=='treatment'"><th mat-header-cell *matHeaderCellDef class="treatment text-center">Treatment</th></div>
          <div *ngIf="column=='lotNumber'"><th mat-header-cell *matHeaderCellDef class="lotNo padding-l10 text-left">Lot Number</th></div>
          <div *ngIf="column=='eligibleUnits'"><th mat-header-cell *matHeaderCellDef class="units text-center">Eligible Units</th></div>
          <div *ngIf="column=='unitsCredited'"><th mat-header-cell *matHeaderCellDef class="dumpedLines text-center">Replant Units</th></div>
          <div *ngIf="column=='uom'"><th mat-header-cell *matHeaderCellDef class="uom text-center">UOM</th></div>
          <div *ngIf="column=='problemDescription'"><th mat-header-cell *matHeaderCellDef class="notes text-center">Customer Notes</th></div>
          <div *ngIf="column=='approverNotes'" [ngClass]="{'d-none': !isApproverUser}">
            <th mat-header-cell *matHeaderCellDef class="notes text-center" [ngClass]="{'d-none': !isApproverUser}">Approver Notes</th>
          </div>
          <td mat-cell *matCellDef="let element">
            <div *ngIf="column=='product'" class="order-info-outer">
              <div class="order-info">
                <p class="prod-id">{{element.itemVendorName}}</p>
                <p class="prod-name" matTooltip="{{element.itemNumber}}" [matTooltipPosition]="'above'" matTooltipClass="whiteFontCpp">{{element.itemDescription}}</p>
              </div>
            </div>
            <div *ngIf="column=='treatment'" class="measureUnit text-center font-14">
              <p class="mb-0"> {{element.treatmentDescription}} </p>
            </div>

            <div *ngIf="column=='lotNumber'" class="measureUnit text-left">
              <p class="mb-0 font18"> {{element.lotNumber}} </p>
            </div>

            <div *ngIf="column=='eligibleUnits'" class="measureUnit text-center">
              <p class="mb-0 font18"> {{element.eligibleUnits}} </p>
            </div>

            <div *ngIf="column=='unitsCredited'" class="quantityBlock text-center">
              <p class="mb-0 font18"> {{element.unitsCredited}} </p>
            </div>

            <div *ngIf="column=='uom'" class="measureUnit text-center">
              <p class="mb-0 font18"> {{element.uom}} </p>
            </div>

            <div *ngIf="column=='problemDescription'" class="measureUnit text-center">
              <textarea readonly type="text descriptionBorder" class="notesTxt" [(ngModel)]="element.problemDescription" maxlength="200"></textarea>
            </div>

            <div *ngIf="column=='approverNotes'" [ngClass]="{'d-none': !isApproverUser}" class="measureUnit text-center">
              <textarea id="txtReplantApproverNotes_{{element.itemNumber}}" type="text" class="notesTxt" [(ngModel)]="element.approverNotes" maxlength="200" (input)="hasDataChanged();"></textarea>
            </div>
          </td>
          </ng-container>

          <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
          <ng-container matColumnDef="expandedDetail">
            <td mat-cell class="product-details" *matCellDef="let element" [attr.colspan]="displayedColumns.length">
              <div class="seller-info pb-2">
                <div class="row">
                  <div class="w-25 padding-r0 text-left padding-l15">
                    <span class="seller-name  pl-2 originalGrowerText">Replant Grower Invoice#:</span>
                    <span class="customer-po-input inVoiceInput borderBottom originalGrowerText">
                      {{element.growerInvoice}}
                    </span>
                  </div>
                  <div class="w-24 padding-l0  padding-l10">
                    <span class="seller-name  originalGrowerText">Replant Date:</span>
                    <span class="text-center deliveryDatePicker borderBottom originalGrowerText">
                      {{element.plantingDate | date: masterConstants.DATE_MMDDYYYY}}
                    </span>
                  </div>
                  <div class="w-15">
                    <span class="customer-po originalGrowerText">
                      Grower License#:
                    </span>
                    <span class="customer-po-input inVoiceInput borderBottom originalGrowerText">
                      {{element.licenseNumber}}
                    </span>
                  </div>
                  <div class="w-15 padding-r0 text-left padding-l15" *ngIf="IsShowTreatment(element)">
                    <span class="seller-name  pl-2 originalGrowerText">Treatment#:</span>
                    <span class="customer-po-input inVoiceInput borderBottom originalGrowerText">
                      {{element.replantTreatmentDescription}}
                    </span>
                  </div>
                  <div class="padding-r0 text-left padding-l15" *ngIf="IsShowTreatment(element)">
                    <span class="seller-name  pl-2 originalGrowerText">Other Treatment#:</span>
                    <span class="customer-po-input inVoiceInput borderBottom originalGrowerText">
                      {{element.otherTreatment}}
                    </span>
                  </div>
                </div>
              </div>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="replantDisplayedColumns;sticky:true;"></tr>
          <tr mat-row *matRowDef="let element; columns: replantDisplayedColumns;"
              class="example-element-row"
              [class.example-expanded-row]="expandedElement === element"
              (click)="expandedElement = expandedElement === element ? null : element"></tr>
          <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
          </table>
        </div>
      </div>
    </div>
  </div>

  <div class="row padding-10 margin-b10 no-gutters contract-info">
    <div class="text-center text-md-left xs-mb-20 md-mb-0 col-md-2 padding-l0 pdfText">
      <span class="md-ml-15 round-icon xs-mr-35 md-mr-15 mobile-round" (click)="generatedPdf()">
        <i class="far fa-file-pdf"></i>
      </span>
      View PDF to Print
    </div>
  </div>

  <div *ngIf="!isApproverUser && !isViewRequest" class="OrderReleaseTop px-3">
    <div class="SeedReplantReview pt-0">
      <div class="row">
        <div class="">
          <div class="py-1">
            <div class="col-md xs-mb-10 md-mb-0 font11">
              <h2>
                Disclaimer:
              </h2>
            </div>
            <div class="col-md xs-mb-15 md-mb-0 font11">
              <h5>
                Acknowledgments
              </h5>
            </div>

            <div class="col-md xs-mb-15 md-mb-0 font11">
              <p class="mb-1">
                <span class="xs-w-95 font11">
                  If a CROPLAN® customer follows proper management practices and does not get a satisfactory stand using qualifying CROPLAN® corn, soybean, canola, grain sorghum and approved alfalfas. CROPLAN® will provide seed for replanting at a discounted price as shown in
                  the current SEED Program Guide. To qualify for the Replant Program any field that is to be replanted must be inspected by your District Manager or Seller before it is replanted. No replant credits will be issued for replanted fields that are not inspected before they are
                  replanted. Replant credit will be given for fields replanted in current year and will not be issued for future years. I agree that the seed I have received is accepted in full satisfaction and extinguishment of all claims and causes faction against CROPLAN®, its sellers,
                  employees and/or agents, arising out of any damage or loss, present or future, to crops, plants or land, direct or indirect, known or unknown, sustained by the undersigned during the current crop season. It is agreed that this is a compromise of a disputed claim and that the
                  making of this payment is not an admission of liability on the part of CROPLAN®. All requests for replant are pending until final approval by the appropriate CROPLAN® product manager.
                </span>
              </p>
            </div>

            <div class="col-md xs-mb-10 md-mb-0 font11">
              <div class="pt-1 checkbox-color">
                <mat-checkbox class="custom-checkbox pr-2" id="chkAgree"
                              [(ngModel)]="agreeToTermsAndConditions"
                              [style.display]=""
                              [checked]=""
                              [indeterminate]=""></mat-checkbox>
                <span class="agreeText">I Agree to the above terms and conditions. </span>
              </div>
            </div>

            <div class="col-md xs-mb-10 md-mb-0 mt-2 font11">
              <h6>
                Winfield Solutions™, LLC, reserves the right to audit all submissions.
              </h6>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="SeedFulfillBtnSec">
    <div class="row padding-l20">
      <div *ngIf="!isApproverUser && !isViewRequest" class="col-md-12 mobile-footer" style="display: contents;">
        <button id="btnSubmitForApproval" *ngIf="!isAutoApprove" mat-raised-button class="btns mr-3" [disabled]="!agreeToTermsAndConditions" (click)="submitRequest()">Submit for Approval</button>
        <button id="btnSubmitForCredit" *ngIf="isAutoApprove" mat-raised-button class="btns mr-3"  [disabled]="!agreeToTermsAndConditions" (click)="approverAction('Approved', true)">Submit For Credit</button>
        <button mat-raised-button class="btns" color="primary" (click)="editRequest()" [style.display]="'inline-block'">Edit Request</button>
      </div>
      <div *ngIf="isApproverUser" class="col-md-12 mobile-footer" style="display: contents;">
        <div class="col-md-9">
          <button id="btnApprove" mat-raised-button class="btns width10 mr-2" color="primary" (click)="approverAction('Approved')">Approve</button>
          <button mat-raised-button class="btns width10 mr-2" color="primary" (click)="editRequest(1)">Edit Request</button>
          <button id="btnReject" mat-raised-button class="btns width10" color="primary" (click)="approverAction('Rejected')" [style.display]="'inline-block'">Reject</button>
        </div>
        <div class="col-md-3 text-right">
          <button mat-raised-button class="btns width10" color="primary" (click)="approverAction('Save')">Save</button>
        </div>
      </div>
      <div *ngIf="isViewRequest" class="col-md-12 mobile-footer" style="display: contents;">
        <button mat-raised-button class="btns" (click)="navigateToLandingPage()">Back to List</button>
      </div>
    </div>
  </div>
</div>
